import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { getRespuestaCuestionario } from "../api/getRespuestaCuestionario";
import { mtUpdateRefAutoTrans } from "../api/mtUpdateRefAutoTrans";
import Header from "../Header/Header";
import foodbrand from "../assets/foodbrand@2x.png";

function ValidarData() {

    const navigate = useNavigate();
    const location = useLocation();
    const preguntas = location.state.preguntas;
    const [preguntasAll, setPreguntasAll] = useState([]);
    const isRunned = useRef(false);

    useEffect(() => {
        if (isRunned.current) return;
        isRunned.current = true;

        async function createSession() {
            setPreguntasAll(preguntas);
        }

        createSession();

    }, []);

    const getConfirmar = async () => {

        // const dataPreguntas = await getRespuestaCuestionario(preguntasAll.preguntas);

        //if (dataPreguntas.status === 200) {

        const objCons = {
            id: localStorage.getItem('idPerson'),
            experiencia: preguntas.preguntas[3].respuestaCorrectaTxt,
            equipo: preguntas.preguntas[2].respuestaCorrectaTxt,
            accidentes: preguntas.preguntas[0].respuestaCorrectaTxt,
            conduccion: preguntas.preguntas[1].respuestaCorrectaTxt,
            distancias: preguntas.preguntas[4].respuestaCorrectaTxt,
            robos: preguntas.preguntas[5].respuestaCorrectaTxt,
            preguntas: preguntasAll.preguntas
        }

        const dataRefAutoTrans = await mtUpdateRefAutoTrans(objCons);
        navigate("/PantallaBase27");
        //  }

    }

    const getReintentar = async () => {
        navigate("/PantallaBase27");
    }
    return (
        <>
            <div className="initBack_P2 animate__animated animate__fadeIn">
                <Header
                    imgBack={true}
                    rutaBack="/QuestionExpProfesional"
                    title="Experiencia profesional"
                    name="ValidarData"
                />
                <div className="containerRender">
                    <div className="containerInfo_P2">
                        <div className="containerIdent_P2">
                            <div className='animate__animated animate__fadeIn'>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p className='txtDocReq_P28'>Experiencia</p>
                                                <p className='txtIdenOf_P28'>
                                                    {preguntas.preguntas[3].respuestaCorrectaTxt}
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p className="txtDocReq_P28">Equipo</p>
                                                <p className='txtIdenOf_P28'>
                                                    {preguntas.preguntas[2].respuestaCorrectaTxt}
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p className='txtDocReq_P28'>Accidentes</p>
                                                <p className='txtIdenOf_P28'>
                                                    {preguntas.preguntas[0].respuestaCorrectaTxt}
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p className='txtDocReq_P28'>Conducción nocturna</p>
                                                <p className='txtIdenOf_P28'>
                                                    {preguntas.preguntas[1].respuestaCorrectaTxt}
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p className='txtDocReq_P28'>Largas distancias</p>
                                                <p className='txtIdenOf_P28'>
                                                    {preguntas.preguntas[4].respuestaCorrectaTxt}
                                                </p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p className='txtDocReq_P28'>Robos</p>
                                                <p className='txtIdenOf_P28'>
                                                    {preguntas.preguntas[5].respuestaCorrectaTxt}
                                                </p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className="footer">
                                    <div className="containerCont_P2">
                                        <button className="button_P2" onClick={getConfirmar}>
                                            <span className="txtButton_P2">Aceptar</span>
                                        </button>
                                        <div className="spaceButton14" />
                                        <button className="buttonRein_P2" onClick={getReintentar}>
                                            <span className="txtButtonRein_P14">Reintentar</span>
                                        </button>
                                    </div>
                                    <div className="imageContainer_P2">
                                        <img src={foodbrand} className="imgFooter_P2" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ValidarData;
